import request from "@/utils/request";

//统计分析表格-左
export function getStatisticalAnalysis(data) {
  return request({
    url: "StatisticalAnalysis/GetStatisticalAnalysis",
    method: "post",
    data,
  });
}
//医院感染发病率
export function getInfectionIncidence(data) {
  return request({
    url: "StatisticalAnalysis/GetInfectionIncidence",
    method: "post",
    data,
  });
}
//医院感染日发病例次率
export function getIncidenceRate(data) {
  return request({
    url: "StatisticalAnalysis/GetIncidenceRate",
    method: "post",
    data,
  });
}
//特定多重耐药菌感染发现率
export function getInfectionDetection(data) {
  return request({
    url: "StatisticalAnalysis/GetInfectionDetection",
    method: "post",
    data,
  });
}
//特定多重耐药菌感染例次发生率
export function getCaseIncidence(data) {
  return request({
    url: "StatisticalAnalysis/GetCaseIncidence",
    method: "post",
    data,
  });
}
//特定多重耐药菌检出率
export function getDetectionRate(data) {
  return request({
    url: "StatisticalAnalysis/GetDetectionRate",
    method: "post",
    data,
  });
}
//特定多重耐药菌患者隔离医嘱开具率
export function getDrawingRate(data) {
  return request({
    url: "StatisticalAnalysis/GetDrawingRate",
    method: "post",
    data,
  });
}
//住院患者抗菌药物使用率
export function getAntibioticsInpatients(data) {
  return request({
    url: "StatisticalAnalysis/GetAntibioticsInpatients",
    method: "post",
    data,
  });
}
//抗菌药物治疗前病原学送检率
export function getDeliveryRate(data) {
  return request({
    url: "StatisticalAnalysis/GetDeliveryRate",
    method: "post",
    data,
  });
}
//Ⅰ类切口手术部位感染率
export function getInfectionRate(data) {
  return request({
    url: "StatisticalAnalysis/GetInfectionRate",
    method: "post",
    data,
  });
}
//Ⅰ类切口手术抗菌药物预防使用率
export function getUtilizationRate(data) {
  return request({
    url: "StatisticalAnalysis/GetUtilizationRate",
    method: "post",
    data,
  });
}
//血管内导管相关血流感染发病率
export function getIncidenceIntravascular(data) {
  return request({
    url: "StatisticalAnalysis/GetIncidenceIntravascular",
    method: "post",
    data,
  });
}
//呼吸机相关肺炎发病率
export function getIncidenceUrinary(data) {
  return request({
    url: "StatisticalAnalysis/GetIncidenceUrinary",
    method: "post",
    data,
  });
}
//导尿管相关泌尿道感染发病率
export function getIncidenceVentilator(data) {
  return request({
    url: "StatisticalAnalysis/GetIncidenceVentilator",
    method: "post",
    data,
  });
}
//医院感染发病率
export function getInfectionIncidence2(data) {
  return request({
    url: "StatisticalAnalysis/GetInfectionIncidence2",
    method: "post",
    data,
  });
}
//医院感染日发病例次率
export function getIncidenceRate2(data) {
  return request({
    url: "StatisticalAnalysis/GetIncidenceRate2",
    method: "post",
    data,
  });
}
//特定多重耐药菌感染发现率
export function getInfectionDetection2(data) {
  return request({
    url: "StatisticalAnalysis/GetInfectionDetection2",
    method: "post",
    data,
  });
}
//特定多重耐药菌感染例次发生率
export function getCaseIncidence2(data) {
  return request({
    url: "StatisticalAnalysis/GetCaseIncidence2",
    method: "post",
    data,
  });
}
//特定多重耐药菌检出率
export function getDetectionRate2(data) {
  return request({
    url: "StatisticalAnalysis/GetDetectionRate2",
    method: "post",
    data,
  });
}
//特定多重耐药菌患者隔离医嘱开具率
export function getDrawingRate2(data) {
  return request({
    url: "StatisticalAnalysis/GetDrawingRate2",
    method: "post",
    data,
  });
}
//住院患者抗菌药物使用率
export function getAntibioticsInpatients2(data) {
  return request({
    url: "StatisticalAnalysis/GetAntibioticsInpatients2",
    method: "post",
    data,
  });
}
//抗菌药物治疗前病原学送检率
export function getDeliveryRate2(data) {
  return request({
    url: "StatisticalAnalysis/GetDeliveryRate2",
    method: "post",
    data,
  });
}
//Ⅰ类切口手术部位感染率
export function getInfectionRate2(data) {
  return request({
    url: "StatisticalAnalysis/GetInfectionRate2",
    method: "post",
    data,
  });
}
//Ⅰ类切口手术抗菌药物预防使用率
export function getUtilizationRate2(data) {
  return request({
    url: "StatisticalAnalysis/GetUtilizationRate2",
    method: "post",
    data,
  });
}
//血管内导管相关血流感染发病率
export function getIncidenceIntravascular2(data) {
  return request({
    url: "StatisticalAnalysis/GetIncidenceIntravascular2",
    method: "post",
    data,
  });
}
//呼吸机相关肺炎发病率
export function getIncidenceUrinary2(data) {
  return request({
    url: "StatisticalAnalysis/GetIncidenceUrinary2",
    method: "post",
    data,
  });
}
//导尿管相关泌尿道感染发病率
export function getIncidenceVentilator2(data) {
  return request({
    url: "StatisticalAnalysis/GetIncidenceVentilator2",
    method: "post",
    data,
  });
}
//计算十二项指标数据
export function computeTwelveIndicators1(data) {
  return request({
    url: "StatisticalAnalysis/ComputeTwelveIndicators1",
    method: "post",
    data,
  });
}
//计算十二项指标数据
export function computeTwelveIndicators2(data) {
  return request({
    url: "StatisticalAnalysis/ComputeTwelveIndicators2",
    method: "post",
    data,
  });
}
//计算十二项指标数据
export function computeTwelveIndicators3(data) {
  return request({
    url: "StatisticalAnalysis/ComputeTwelveIndicators3",
    method: "post",
    data,
  });
}

//抗菌药物
export function getMedicine(data) {
  return request({
    url: "InfectionPosition/GetMedicine",
    method: "post",
    data,
  });
}

//感染部位
export function getInfectionPosition(data) {
  return request({
    url: "InfectionPosition/GetInfectionPosition",
    method: "post",
    data,
  });
}

//00
export function getYear_Month(data) {
  return request({
    url: "Upload/GetYear_Month",
    method: "post",
    data,
  });
}

//患者记录
export function getPatientInfo(data) {
  return request({
    url: "PatientInfo/GetPatientInfo",
    method: "post",
    data,
  });
}
//患者记录
export function getExportPatientInfo(data) {
  return request({
    url: "PatientInfo/GetExportPatientInfo",
    method: "post",
    data,
  });
}
//转科记录
export function getChangekeshi(data) {
  return request({
    url: "Changekeshi/GetChangekeshi",
    method: "post",
    data,
  });
}
//转科记录
export function getExportChangekeshi(data) {
  return request({
    url: "Changekeshi/GetExportChangekeshi",
    method: "post",
    data,
  });
}
//感染记录
export function getInfectedInfo(data) {
  return request({
    url: "InfectedInfo/GetInfectedInfo",
    method: "post",
    data,
  });
}
//感染记录
export function getExportInfectedInfo(data) {
  return request({
    url: "InfectedInfo/GetExportInfectedInfo",
    method: "post",
    data,
  });
}
//送检记录
export function getInspectionInfo(data) {
  return request({
    url: "InspectionInfo/GetInspectionInfo",
    method: "post",
    data,
  });
}
export function getExportInspectionInfo(data) {
  return request({
    url: "InspectionInfo/GetExportInspectionInfo",
    method: "post",
    data,
  });
}
//微生物培养
export function getMicroorganism(data) {
  return request({
    url: "Microorganism/GetMicroorganism",
    method: "post",
    data,
  });
}
export function getExportMicroorganism(data) {
  return request({
    url: "Microorganism/GetExportMicroorganism",
    method: "post",
    data,
  });
}
//药敏结果
export function getDrugsensitivity(data) {
  return request({
    url: "Drugsensitivity/GetDrugsensitivity",
    method: "post",
    data,
  });
}
export function getExportDrugsensitivity(data) {
  return request({
    url: "Drugsensitivity/GetExportDrugsensitivity",
    method: "post",
    data,
  });
}
//器械相关医嘱
export function getApparatus(data) {
  return request({
    url: "Apparatus/GetApparatus",
    method: "post",
    data,
  });
}
export function getExportApparatus(data) {
  return request({
    url: "Apparatus/GetExportApparatus",
    method: "post",
    data,
  });
}
//抗菌药物
export function getAntibiotics(data) {
  return request({
    url: "Antibiotics/GetAntibiotics",
    method: "post",
    data,
  });
}
export function getExportAntibiotics(data) {
  return request({
    url: "Antibiotics/GetExportAntibiotics",
    method: "post",
    data,
  });
}
//手术记录
export function getOperation(data) {
  return request({
    url: "Operation/GetOperation",
    method: "post",
    data,
  });
}
export function getExportOperation(data) {
  return request({
    url: "Operation/GetExportOperation",
    method: "post",
    data,
  });
}
//诊断记录
export function getDiagnosis(data) {
  return request({
    url: "Diagnosis/GetDiagnosis",
    method: "post",
    data,
  });
}
export function getExportDiagnosis(data) {
  return request({
    url: "Diagnosis/GetExportDiagnosis",
    method: "post",
    data,
  });
}
//体温记录
export function getTemperature(data) {
  return request({
    url: "Temperature/GetTemperature",
    method: "post",
    data,
  });
}
export function getExportTemperature(data) {
  return request({
    url: "Temperature/GetExportTemperature",
    method: "post",
    data,
  });
}
//科室信息
export function getDicDept(data) {
  return request({
    url: "DicDept/GetDicDept",
    method: "post",
    data,
  });
}
export function getExportDicDept(data) {
  return request({
    url: "DicDept/ExportDicDept",
    method: "post",
    data,
  });
}
//血透记录
export function getHemodialysis(data) {
  return request({
    url: "_14hemodialysis/GetHemodialysis",
    method: "post",
    data,
  });
}
//血透报表
export function getStatement(data) {
  return request({
    url: "_15_statement/GetStatement",
    method: "post",
    data,
  });
}
export function getExportStatement(data) {
  return request({
    url: "_15_statement/GetExportStatement",
    method: "post",
    data,
  });
}
//手卫生数据
export function gethandhygiene(data) {
  return request({
    url: "handhygiene/Gethandhygiene",
    method: "post",
    data,
  });
}
//查询包号
export function get_00_packinfo(data) {
  return request({
    url: "_00packinfo/Get_00_packinfo",
    method: "post",
    data,
  });
}
//统计分析表格-新
export function getCalculationIndexResults(data) {
  return request({
    url: "StatisticalAnalysis/CalculationIndexResults",
    method: "post",
    data,
  });
}



// WEBPACK FOOTER //
// ./src/api/search.js